import { render, staticRenderFns } from "./AddDid.vue?vue&type=template&id=05ab78d2&scoped=true&"
import script from "./AddDid.vue?vue&type=script&lang=js&"
export * from "./AddDid.vue?vue&type=script&lang=js&"
import style0 from "./AddDid.vue?vue&type=style&index=0&id=05ab78d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab78d2",
  null
  
)

component.options.__file = "AddDid.vue"
export default component.exports